<script setup lang="ts">
import { ref } from 'vue';
import { ArrowDown } from '@element-plus/icons-vue';
import { setLocale, getCurrentLocale, availableLocales, type Locale } from '@/shared/i18n';
import { ElButton, ElDropdown, ElDropdownItem, ElDropdownMenu, ElIcon } from 'element-plus';


interface Props {
  size?: 'default' | 'small' | 'large';
  buttonClass?: string;
}

withDefaults(defineProps<Props>(), {
  size: 'default',
  buttonClass: '',
});

const currentLocale = ref<Locale>(getCurrentLocale());

function handleLanguageChange(locale: Locale): void {
  setLocale(locale);
  currentLocale.value = locale;
}
</script>

<template>
  <ElDropdown @command="handleLanguageChange" trigger="click">
    <ElButton :size="size" class="language-btn" :class="[buttonClass]">
      {{ currentLocale.toUpperCase() }}
      <ElIcon class="el-icon--right">
        <ArrowDown />
      </ElIcon>
    </ElButton>
    <template #dropdown>
      <ElDropdownMenu>
        <ElDropdownItem
          v-for="locale in availableLocales"
          :key="locale.code"
          :command="locale.code"
          :disabled="locale.code === currentLocale"
        >
          {{ locale.nativeName }}
        </ElDropdownItem>
      </ElDropdownMenu>
    </template>
  </ElDropdown>
</template>

<style scoped>
.language-btn {
  min-width: 50px;
  font-weight: 600;
}
</style>

